module.exports = __webpack_public_path__ + "static/other/gameUniformDesignHuman.4db2a0b9.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniformDesignHuman.json
// module id = 2546
// module chunks = 0